import React, { Component } from 'react';
import {Log} from 'ng2-logger';
import ReactCrop from 'react-image-crop';
import {connect} from 'react-redux';

const _logger = Log.create('image-crop');

export class ImageCrop extends Component<any, any> {

    public imageRef : any = null;
    public fileUrl : any = null;

    constructor(props: any) {
        super(props);
        this.state = {
            imageBlob: null,
            src: null,
            crop: {
              unit: '%',
              width: 40,
              aspect: 1
            }
        };
    }

    public onSelectFile = (e:any) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({ src: reader.result })
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };

      // If you setState the crop in here you should return false.
    public onImageLoaded = (image:any) => {
        this.imageRef = image;
    };

    public onCropComplete = (crop:any) => {
        /* tslint:disable-next-line */
        this.makeClientCrop(crop);
    };

    public onCropChange = (crop:any, percentCrop:any) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    public async makeClientCrop(crop:any) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
            this.imageRef,
            crop,
            'newFile.png'
            );
            this.setState({ croppedImageUrl });
            this.props.setImage(this.state.imageBlob);
        }
    }

    public getCroppedImg(image:any, crop:any, fileName:any) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');
    
        if(ctx) {
            ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
            );
        }
    
        return new Promise((resolve, reject) => {
          canvas.toBlob((blob:any) => {
            if (!blob) {
              return;
            }
            this.setState({ imageBlob: blob });
            blob.name = fileName;
            window.URL.revokeObjectURL(this.fileUrl);
            this.fileUrl = window.URL.createObjectURL(blob);
            resolve(this.fileUrl);
          }, 'image/png');
        });
      }

    public render() {
        const { crop, croppedImageUrl, src } = this.state;

        return (
            <div style={{ marginTop: '15px' }}>
                <div>
                    <input name="file-input" style={{ display: 'none' }} type="file" accept="image/*" onChange={this.onSelectFile} />
                </div>
                {src && (
                <ReactCrop
                    src={src}
                    crop={crop}
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                />
                )}
                {croppedImageUrl && (
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
                    </div>
                )}
            </div>
        );
    }
}

export default ImageCrop;
